<template>
    <section class="container">
        <ul>

        </ul>
        <h1>Examples of vue-chartjs</h1>
        <div class="columns">
            <div class="column">
                <h3>Line Chart</h3>
                <line-chart/>
            </div>
            <div class="column">
                <h3>Bar Chart</h3>
                <bar-chart/>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <h3>Bubble Chart</h3>
                <bubble-chart/>
            </div>
            <div class="column">
                <h3>Reactivity - Live update upon change in datasets</h3>
                <reactive :chart-data="datacollection"/>
                <button class="button is-primary" @click="fillData()">Randomize</button>
            </div>

        </div>
    </section>
</template>
<script>
import LineChart from './LineChart'
import BarChart from './BarChart'
import BubbleChart from './BubbleChart'
import Reactive from './Reactive'
export default {
  name: 'VueChartJS',
  components: {
    LineChart,
    BarChart,
    BubbleChart,
    Reactive
  },
  data () {
    return {
      datacollection: null // instantiating datacollection with null
    }
  },
  created () {
    this.fillData() // anytime the vue instance is created, call the fillData() function.
  },
  methods: {
    fillData () {
      this.datacollection = {
        // Data for the y-axis of the chart
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
          'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            // Data for the x-axis of the chart
            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(),
              this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(),
              this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    },
    getRandomInt () {
      // JS function to generate numbers to be used for the chart
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  }
}
</script>
